import React from "react";
import "./sema.scss";
import { ArrowButton } from "../../components/arrow-button";
import { PhotoColumn } from "../../components/photo-column";
import Bisiklet from '../../assets/icons/bisiklet-transparent-241.jpg';
import Semazen from '../../assets/icons/semazen-renkli.png';

interface SemaVeBisikletSurmekProps {
    isVisible: boolean;
    comeBackSemaSection: Function;
}
interface SemaVeBisikletSurmekState {
    Change: boolean;
}


class SemaVeBisikletSurmek extends React.Component<SemaVeBisikletSurmekProps, SemaVeBisikletSurmekState> {
    constructor(props: any) {
        super(props);
        this.state = {
            Change: true
        };
    }

    render() {
        return (
            <article style={{ display: this.props.isVisible ? "block" : "none" }}>
                <ArrowButton onClick={this.props.comeBackSemaSection} />
                <h3 className="title">SEMA’NIN VE BİSİKLET SÜRMENİN ORTAK TARAFLARI</h3>
                <PhotoColumn
                    imageSource={Semazen}
                    imageTitle="Sema Ve Bisiklet Sürmenin Ortak Tarafları"
                />

                <p>
                    Sufi öğretisi üzerine <span className="highlight-word">SEMA</span> törenine hazırlanırken bir şeyi öğrenmiştik: Sufilikte sormadan hiçbir şey olmuyor.
                    Kim soru sormazsa cevap da almıyor. “Her defasında tekrar tekrar sorun!” denildiğini duyuyorduk. Burada her
                    türlü soruya bir cevap alındığı anlamı çıkmamalıdır. Sorular elbette ki belirli nitelikleri taşımalıdır.
                    Sadece merak ve basit bilgi ihtiyacından doğan sorular, daha başlangıçtan itibaren cevaplandırılan soruların
                    dışında kalıyor. Bu tür sorular cevaplansa da, gecikmeli ve istenmeyerek cevaplandırılıyor. Peki, geriye hangi
                    tür sorular kalıyor? Sorular, kalpten gelen sorular olmalıdır. Cevabını buluncaya kadar bir ömür boyunca
                    sorulan sorular. Ve cevaplandırılmasıyla belirli şartlarda hayatı baş aşağı çeviren sorular.
                </p>

                <p>
                    Batı Avrupa’da ve Amerika’da bilgi, enformasyonda ileri olma ve güç anlamındadır. Bizde ise bilgi, kalben
                    tanımanın bir aşamasıdır. Bu bilgi icraattan doğmaktadır. Batı Avrupa ve Amerika’dan gelen insanlar daha çok
                    bir iki günde hayatın özünü yakalamak istiyorlar. Bu mümkün olmayacağından, devamlı bir şekilde hayal
                    kırıklığına uğruyorlar. Burada bunlar sadece biraz zaman ve sabrı da beraberinde getirecek olsalar, ne
                    aradıklarını bulabilirler. Zira sufi yolunda ilerlemek belirli şartlara bağlanmıştır. Ancak bundan size daha
                    sonra bahsedeceğim...
                </p>

                <p>
                    Buna karşı ne yapılabilir? Ziyaretçilerin büyük bir kısmı sadece yüzeysel olarak intiba edinmeye çalışıyorlar.
                    Bunlar için ülkemizde yeterince manevi hediyelikler bulunuyor. Sufilerin, dervişlerin ve folklorik türden
                    benzeri şeylerin hatıra fotoğrafları. Böylesi bir tavır üzüntü verici değil mi? Evet, sufi yoluna girmek için
                    bu uygun bir şey değildir. Sufi geleneğinde bir cümle şöyle diyor:
                    <span className="text-bold-italic">
                        “Öğreninceye kadar tetkik edeceğiz! (denetleyeceğiz araştıracağız!) Ve sırlarımızı kiminle paylaşacağımızı elbette ki çok iyi tetkik edeceğiz.”
                    </span>
                </p>

                <p>
                    <span className="highlight-word">SEMA</span> eğitimi almaya gelen yerli ve yabancı talebeler ile yukarıdaki değerlendirmeleri yaptıktan sonra,
                    alakalarını görmek bir <span className="highlight-word">SEMA</span> Dedesi olarak bizi memnun etti.
                    Bunun üzerine <span className="text-bold-italic">“Şok!”</span> dedim. Çünkü cevapları beni aşikâr bir halde sevindirdi.
                    <span className="text-bold-italic">“Siz bilmelisiniz”</span> diye müşahede ederek,
                    <span className="text-bold-italic">
                        “Şayet insan söylenmeyecek bir şeyle karşılaşırsa şok meydana gelir. Bu meydana gelecek olanın en iyisidir.
                        Zira bu, sizin alakadar olduğunuz anlamına gelmektedir.”
                    </span> diyerek, izahatla devam ediyorum:
                </p>

                <p className="text-bold-italic">
                    “<span className="highlight-word">SEMA</span>, kâinat dengesine ait merasimin usul ve kurallarıdır. <span className="highlight-word">SEMA</span> nedir biliyor musun? İnsanın yaratılış
                    tiyatrosudur. Açık veya kapalı havada cereyan eder.
                    <p className="verse-text">Oyuncular... </p>
                    <p className="verse-text">Şaşırtıcı!</p>
                    <p className="verse-text">Yalnızca bir kişi: SEN!</p>
                </p>

                <p className="text-bold-italic">
                    Kim olursan ol, kadın ol, erkek ol <span className="highlight-word">SEMA</span> herkese hitab eder, siyah ol, beyaz ol, genç ol, yaşlı ol bu sahneye
                    katıldığına göre başrol senin. Tek bir şart var: Aşk ve vecd’in olması.
                </p>
                <p className="text-bold-italic">
                    Her Semazen, derviş veya sufi bunun içinde kendisi için belirlenmiş olan yeri almaktadır. Bütün katılımcıların
                    pozisyonu, güneşin, ayın ve yıldızların birlikteliğini ifade etmektedir. Bununla büyük dönme, <span className="highlight-word">SEMA</span>’da imanda
                    kökleşme, kâinattaki seyre benzemektedir. Nasıl ki yıldızlar güneşin etrafında uyum içerisinde dönüyorlar,
                    sufiler de <span className="highlight-word"><span className="highlight-word">ALLAH</span></span>’ta ve çevresinde dönüyorlar. Gelenekte bu, <span className="highlight-word">SEMA</span> ile <span className="highlight-word">ALLAH</span>’ın enerjisinin dünyanın
                    istifadesine sunulması anlamına gelmektedir. Şayet insan bu enerjiyle hazırlıksız olarak temas edecek olursa,
                    burada pekâlâ bir şokun meydana gelmesine sebebiyet verir!”
                </p>
                <p>
                    Bunun üzerine eğitime gelen talebelerden yabancı olan biri:
                </p>
                <p>
                    –“Evet, haklısınız. Ben bu şoku yaşadım, ancak bunun altında gizli bir şeyler saklı. Sevinç, ilgi ve hasret”
                    diyor ve tüm cesaretini toplayarak soruyor:
                </p>
                <p>
                    –“Ben kendimi SEMA’dan öyle etkilenmiş hissediyorum ki, sadece şunu söyleyebilirim. Şayet bir şekilde olacaksa
                    ben de <span className="highlight-word">SEMA</span>’yı yaşamak istiyorum. SEMA’nın şartlarından bahsettiniz. Ben bu şartları yerine getirebilir
                    miyim?”
                </p>
                <p>
                    –“Bisiklet sürebilir misin?” sorusuyla cevap veriyorum. –“Evet, elbette!” diyor şaşırarak.
                </p>
                <p>
                    –“O halde SEMA’nın şartlarını yerine getirebilirsin!” diyorum.
                </p>
                <p>
                    Belli ki şüphe ediyor, aklı karışıyor. Ve “Daha önce bazı şeylerin göründüğü gibi olmadığını öğrenmiştim ve
                    bu, bazen konuşulan için de geçerlidir” diye cümleye girip, beklediğim soruyu soruyor:
                </p>

                <PhotoColumn
                    imageSource={Bisiklet}
                    imageTitle="Sema Ve Bisiklet Sürmenin Ortak Tarafları"
                />
                <p>
                    –“SEMA’yı bisiklet sürmekle neden karşılaştırıyorsunuz? Birisi ruhani bir yol, bisiklet sürmekse bisiklet
                    sürmek. Bunların ortak noktaları nerede bulunuyor? Sufiler dönüyorlar ve bisikletin tekerleği de. <span className="highlight-word">SEMA</span>,
                    bisiklet sürmenin ruhani bir türü mü?”
                </p>
                <p>
                    Bu soru beni gülümsetiyor. Yüz ifadesi ‘hedef tutmadı’ şeklinde. İncinmiş ve gülünç duruma düşmüş olduğu
                    hissiyle tepki veriyor. Ama her şeye rağmen etrafındakilere baktığında, gülünç olmadığını görüyor ve bundan
                    cesaret alarak tekrar soruyor: –“Peki, <span className="highlight-word">SEMA</span>’nın bisiklet sürme ile ilgisi nedir?” Son bir kez gülümseyerek şu
                    cevabı veriyorum:
                </p>
                <p>
                    –“<span className="highlight-word">SEMA</span>, ruhani bisiklet sürme olarak görülür! Harikulade bir şey değil mi! Bisiklet sürmeyi nasıl öğrendiğini
                    hatırla! Burada ne kadar güvensizliğe düştüğünü hatırla! Bu esnada her defasında serbestçe sürme halini
                    kendinde gördün. Belki düştün ve tekrar sürmeye çalıştın... Hatırla!”
                    Hatırlıyor ve anlatmaya başlıyor:
                </p>
                <p>
                    –“Evet, evet! Bisiklete binerken çekilmiş çocukluk resimlerimi hatırlıyorum. Çoğunlukla beni bisikletin
                    üstünde tutan ve benimle birlikte gelen birisini bulurdum. Eski ve bana göre büyük bir bisikleti sürmeyi
                    deniyor, küçük olduğum için bisikletin üstüne oturamıyordum. Bisiklete binerken oldukça eziyet çekiyordum. Bir
                    gün, -bu anı sanki tüm benliğimde hala hissediyorum- beni yönlendiren kişinin elinden kurtulup kendi başıma
                    kaldım. Bir an büyük bir korkuya kapıldım ve nihayetinde ilk kez kendi başıma bisikleti sürebilmiştim. Artık
                    sürmeyi hiç ama hiç bırakmak istemiyor. dum. Bulduğum vaktin her dakikasını bisiklet sürmek için kullanmak ve
                    bununla kendimi daha çok emniyete almak istiyordum. Bisiklet sürmek hayat ufkumu birdenbire geliştirmişti. O
                    zaman kendimi ne kadar da mutlu ve güçlü hissetmiştim!”
                </p>

                <p>
                    Bu anlatımının üzerine <span className="highlight-word">SEMA</span> Dedesi olarak tekrar söze girip cevap veriyorum:
                </p>
                <p>
                    –“Görüyor musun, <span className="highlight-word">SEMA</span> için ihtiyacınız olan hedefe yönelik arzu, eğitimde kararlılık ve sabır; cesaretle
                    güvensizliği ve başarısızlığı yenme ve bağları terk etme şartları hepimizde mevcut. En önemli olan bisiklet
                    sürmeye kendini adamakla bisiklet sürme doğuyor. Bunların hepsi, hakiki ve güzel sufi ruhunun esaslarıdır. Biz
                    bunu, esas gücün eğitimi veya nefsin terbiyesi diye adlandırıyoruz.”
                </p>
                <p>
                    –“Kim gerçekten bisiklet sürmek isterse, bununla ilgili sade bir talimatnameyi yeterli görmeyebilir. O kendi
                    deneyimini gerçekleştirmek için bir gün bisiklete binmeye mecburdur. Batılı insanların yemek yerine menü
                    kartıyla yetindiklerini söylerken buna işaret etmiştim. Hatta bunlar o yemeklerden tatmasalar bile menü kartı
                    üzerine ilmi araştırmalar bile yapabilirler. Bu şu anlama geliyor: Bunların bilgileri şahsi deneyimlerle yaşam
                    sürecinde kazanılmayıp, bilakis korunmuş (konserve edilmiş) halde aktarılmaktadır.”
                </p>
                <p>
                    “Buna karşılık <span className="highlight-word">SEMA</span>, her defasında doğrudan elde edilen deneyimle şimdiki zamanda doğmaktadır. SEMA’nın
                    içerisine bizim gerçekten kim olduğumuz hatırlatması konulmuştur. Bunun anahtarı doğrudan elde edilecek
                    kişisel deneyimdir. Bu deneyim olmadan gerçek bir anlama olmaz! Merkezi nokta icraattır. Bisiklet sürmeye
                    hayrete şayan bir paralellik görüyor musun? İcraatsız bisiklet sürme ve icraatsız <span className="highlight-word">SEMA</span> olmaz. Kim ki,
                    yönlendiren elin bırakıldığı anda ve bununla bağlantılı olarak o serbestliği yaşamadıysa, buradaki büyüleyici
                    olan şeyi anlayamaz. Kim <span className="highlight-word">ALLAH</span>’ın sonsuz nimetlerine SEMA’da dalmadıysa, neyin ne olduğunu nasıl anlayabilir?
                    Ancak şu kadar da olsa kelimelerle ifade etmek mümkün: <span className="highlight-word">SEMA</span>, umulmadık özgürlüklerin kapısıdır.”
                </p>
                <p>
                    “Ve başka bir ortak tarafı daha var. Disiplinsiz ne bisiklet sürme, ne de <span className="highlight-word">SEMA</span> olamaz. Hem burada hem de orada
                    eğitim yapmaya ve engelleri aşmaya mecbursunuz. Bu durum bizim geleneğimizde nefsin terbiyesi olarak
                    adlandırılmaktadır. Bizim anlayışımızla nefs, frenlenemeyen, kendi bencilliğimizin bir parçasıdır. Başka bir
                    ifadeyle, içimizdeki hayvandır. En basit şekliyle nefs, ego ile karşılaştırılabilir. Nefs terbiye edilmelidir.
                    Aksi takdirde <span className="highlight-word">ALLAH</span>’la olan her türlü irtibat ve bağlantı kopmaktadır. <span className="highlight-word">SEMA</span>’ya götüren maneviyat, burada
                    dünyamızda doğuyor, eğitiliyor ve adım adım ruhun başka boyutlarına götürüyor.”
                </p>

                <p>
                    “O halde kim SEMA’nın deneyimine karar verirse, bunun vücut ve ruh jimnastiği olmadığını kabul etmelidir. Aksi
                    takdirde ego yoluna gidilir. <span className="highlight-word">SEMA</span>, bir mönü kartı değil, bilakis yemeğin kendisidir! SEMA’nın başındaki inanç,
                    <span className="highlight-word">ALLAH</span>’tan başka ilah yoktur! diye ifade edilir. Bu, İslamiyet’te ve sufi yolundaki en önemli inançtır. Bu,
                    <span className="highlight-word">ALLAH</span>’ın dışındaki her şeyin açıkça reddedildiği çok açık bir ifadedir. Aramanın amacı sadece <span className="highlight-word">ALLAH</span>’ı
                    bulmaktır. Arama bu doğrultuda olduğu takdirde <span className="highlight-word"><span className="highlight-word"><span className="highlight-word">ALLAH</span></span></span> kulunu kendisine yaklaştırıyor. Bundan sonra sufi yolu
                    konusunda endişeye kapılmaya gerek kalmıyor.”
                </p>
                <p>
                    Bu Mesnev-i Şerifte şöyle ifade ediliyor: Sadece susayanlar suyu aramaz, Su da susayanları arar durur!
                </p>

            </article>
        );
    }
}

export default SemaVeBisikletSurmek;